export const createWhiteboardNodeSpec = () => ({
    marks: "",
    group: "block",
    atom: true,
    isolating: true,
    attrs: {
        width: { default: null },
        height: { default: null },
        whiteboardId: { default: null },
        whiteboardCopyId: { default: null },
        textAlign: { default: null },
        createdAt: { default: null },
        updatedAt: { default: null },
    },
    draggable: false,
    selectable: true,
    toDOM: (node) => {
        return [
            "span",
            {
                "data-ss-whiteboard": "true",
                "data-width": node.attrs.width,
                "data-height": node.attrs.height,
                "data-whiteboard-id": node.attrs.whiteboardId,
                "data-text-align": node.attrs.textAlign || "left",
                "data-created-at": node.attrs.createdAt,
                "data-updated-at": node.attrs.updatedAt,
            },
        ];
    },
    parseDOM: [
        {
            tag: "span[data-ss-whiteboard]",
            getAttrs: (dom) => {
                const domElement = dom;
                return {
                    width: domElement.getAttribute("data-width"),
                    height: domElement.getAttribute("data-height"),
                    whiteboardCopyId: domElement.getAttribute("data-whiteboard-id"),
                    textAlign: domElement.getAttribute("data-text-align"),
                    createdAt: domElement.getAttribute("data-created-at"),
                    updatedAt: domElement.getAttribute("data-updated-at"),
                };
            },
        },
    ],
});
export const whiteboardNodesSpec = () => ({
    whiteboard: createWhiteboardNodeSpec(),
});
